import axios from "../../axios/axios";

import history from "../../history";

import * as apis from "../../apis";
import * as errors from "../../errors"
import * as successes from "../../successes"
import * as routes from "../../routes";

import { getAxiosTokenConfig } from "../../helpers";

import { notifyError, notifySuccess } from "../../toast-notifications";


export const TOGGLE_ORDER_MODAL = "TOGGLE_ORDER_MODAL";
export const TOGGLE_MANUAL_ORDER_MODAL = "TOGGLE_MANUAL_ORDER_MODAL";
export const TOGGLE_ORDER_PRODUCT_MODAL = "TOGGLE_ORDER_PRODUCT_MODAL";
export const TOGGLE_ORDER_SHIFT_MODAL = "TOGGLE_ORDER_SHIFT_MODAL";
export const TOGGLE_ORDER_SHIFT_SUMMARY_MODAL = "TOGGLE_ORDER_SHIFT_SUMMARY_MODAL";

// GET ORDER SETTINGS
export const GET_ORDER_SETTINGS_REQUEST = "GET_ORDER_SETTINGS_REQUEST";
export const GET_ORDER_SETTINGS_SUCCESS = "GET_ORDER_SETTINGS_SUCCESS";
export const GET_ORDER_SETTINGS_ERROR = "GET_ORDER_SETTINGS_ERROR";

export const getOrderSettingsRequest = () => {
    return {
        type: GET_ORDER_SETTINGS_REQUEST,
        loading: true
    };
};
export const getOrderSettingsSuccess = (orderSettings) => {
    return {
        type: GET_ORDER_SETTINGS_SUCCESS,
        loading: false,
        error: null,
        orderSettings
    };
};
export const getOrderSettingsError = (error) => {
    return {
        type: GET_ORDER_SETTINGS_ERROR,
        loading: false,
        error
    };
};
export const getOrderSettings = () => {
    return dispatch => {
        dispatch(getOrderSettingsRequest());
        axios.get(apis.GET_ORDER_SETTINGS_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(getOrderSettingsSuccess(response.data));
            })
            .catch(error => {
                dispatch(getOrderSettingsError(errors.GET_ORDER_SETTINGS_ERROR));
                notifyError(errors.GET_ORDER_SETTINGS_ERROR);
            });
    };
};

// UPDATE ORDER SETTINGS
export const UPDATE_ORDER_SETTINGS_REQUEST = "UPDATE_ORDER_SETTINGS_REQUEST";
export const UPDATE_ORDER_SETTINGS_SUCCESS = "UPDATE_ORDER_SETTINGS_SUCCESS";
export const UPDATE_ORDER_SETTINGS_ERROR = "UPDATE_ORDER_SETTINGS_ERROR";

export const updateOrderSettingsRequest = () => {
    return {
        type: UPDATE_ORDER_SETTINGS_REQUEST,
        loading: true
    };
};
export const updateOrderSettingsSuccess = (orderSettings) => {
    return {
        type: UPDATE_ORDER_SETTINGS_SUCCESS,
        loading: false,
        error: null,
        orderSettings
    };
};
export const updateOrderSettingsError = (error) => {
    return {
        type: UPDATE_ORDER_SETTINGS_ERROR,
        loading: false,
        error
    };
};
export const updateOrderSettings = (orderSettings) => {
    return dispatch => {
        dispatch(updateOrderSettingsRequest());
        axios.patch(apis.UPDATE_ORDER_SETTINGS_API, orderSettings, getAxiosTokenConfig())
            .then(response => {
                dispatch(updateOrderSettingsSuccess(response.data));
                notifySuccess(successes.UPDATE_ORDER_SETTINGS_SUCCESS);
            })
            .catch(error => {
                dispatch(updateOrderSettingsError(error));
                notifyError(errors.UPDATE_ORDER_SETTINGS_ERROR);
            });
    };
};

// GET ORDER_SHIFTS
export const GET_ORDER_SHIFTS_REQUEST = "GET_ORDER_SHIFTS_REQUEST";
export const GET_ORDER_SHIFTS_SUCCESS = "GET_ORDER_SHIFTS_SUCCESS";
export const GET_ORDER_SHIFTS_ERROR = "GET_ORDER_SHIFTS_ERROR";

export const getOrderShiftsRequest = () => {
    return {
        type: GET_ORDER_SHIFTS_REQUEST,
        loading: true
    };
};
export const getOrderShiftsSuccess = (orderShifts) => {
    return {
        type: GET_ORDER_SHIFTS_SUCCESS,
        loading: false,
        error: null,
        orderShifts
    };
};
export const getOrderShiftsError = (error) => {
    return {
        type: GET_ORDER_SHIFTS_ERROR,
        loading: false,
        error
    };
};
export const getOrderShifts = () => {
    return dispatch => {
        dispatch(getOrderShiftsRequest());
        axios.get(apis.GET_ORDER_SHIFTS_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(getOrderShiftsSuccess(response.data));
            })
            .catch(error => {
                dispatch(getOrderShiftsError(errors.GET_ORDER_SHIFTS_ERROR));
                notifyError(errors.GET_ORDER_SHIFTS_ERROR);
            });
    };
};

// ADD ORDER_SHIFT
export const ADD_ORDER_SHIFT_REQUEST = "ADD_ORDER_SHIFT_REQUEST";
export const ADD_ORDER_SHIFT_SUCCESS = "ADD_ORDER_SHIFT_SUCCESS";
export const ADD_ORDER_SHIFT_ERROR = "ADD_ORDER_SHIFT_ERROR";

export const addOrderShiftRequest = () => {
    return {
        type: ADD_ORDER_SHIFT_REQUEST,
        loading: true
    };
};
export const addOrderShiftSuccess = (orderShift) => {
    return {
        type: ADD_ORDER_SHIFT_SUCCESS,
        loading: false,
        error: null,
        orderShift
    };
};
export const addOrderShiftError = (error) => {
    return {
        type: ADD_ORDER_SHIFT_ERROR,
        loading: false,
        error
    };
};
export const addOrderShift = (orderShift, shiftDates) => {
    return dispatch => {
        dispatch(addOrderShiftRequest());

        const newOrderShift = {
            ...orderShift,
            dates: [...shiftDates]
        }

        axios.post(apis.ADD_ORDER_SHIFT_API, newOrderShift, getAxiosTokenConfig())
            .then(response => {
                dispatch(addOrderShiftSuccess(response.data));
                notifySuccess(successes.ADD_ORDER_SHIFT_SUCCESS);
            })
            .catch(error => {
                dispatch(addOrderShiftError(errors.ADD_ORDER_SHIFT_ERROR));
                notifyError(errors.ADD_ORDER_SHIFT_ERROR);
            })
            .finally(res => {
                dispatch({ type: TOGGLE_ORDER_SHIFT_MODAL });
            });
    };
};

// DELETE ORDER_SHIFT
export const DELETE_ORDER_SHIFT_REQUEST = "DELETE_ORDER_SHIFT_REQUEST";
export const DELETE_ORDER_SHIFT_SUCCESS = "DELETE_ORDER_SHIFT_SUCCESS";
export const DELETE_ORDER_SHIFT_ERROR = "DELETE_ORDER_SHIFT_ERROR";

export const deleteOrderShiftRequest = () => {
    return {
        type: DELETE_ORDER_SHIFT_REQUEST,
        loading: true
    };
};
export const deleteOrderShiftSuccess = (orderShiftId) => {
    return {
        type: DELETE_ORDER_SHIFT_SUCCESS,
        loading: false,
        error: null,
        orderShiftId
    };
};
export const deleteOrderShiftError = (error) => {
    return {
        type: DELETE_ORDER_SHIFT_ERROR,
        loading: false,
        error
    };
};
export const deleteOrderShift = (id) => {
    return dispatch => {
        dispatch(deleteOrderShiftRequest());
        axios.delete(apis.DELETE_ORDER_SHIFT_API + id + "/", getAxiosTokenConfig())
            .then(response => {
                dispatch(deleteOrderShiftSuccess(id));
                notifySuccess(successes.DELETE_ORDER_SHIFT_SUCCESS);
            })
            .catch(error => {
                dispatch(deleteOrderShiftError(error));
                notifyError(errors.DELETE_ORDER_SHIFT_ERROR);
            })
            .finally(res => {
                dispatch({ type: TOGGLE_ORDER_SHIFT_MODAL });
            });
    };
};

// UPDATE ORDER_SHIFT
export const UPDATE_ORDER_SHIFT_REQUEST = "UPDATE_ORDER_SHIFT_REQUEST";
export const UPDATE_ORDER_SHIFT_SUCCESS = "UPDATE_ORDER_SHIFT_SUCCESS";
export const UPDATE_ORDER_SHIFT_ERROR = "UPDATE_ORDER_SHIFT_ERROR";

export const updateOrderShiftRequest = () => {
    return {
        type: UPDATE_ORDER_SHIFT_REQUEST,
        loading: true
    };
};
export const updateOrderShiftSuccess = (orderShift) => {
    return {
        type: UPDATE_ORDER_SHIFT_SUCCESS,
        loading: false,
        error: null,
        orderShift
    };
};
export const updateOrderShiftError = (error) => {
    return {
        type: UPDATE_ORDER_SHIFT_ERROR,
        loading: false,
        error
    };
};
export const updateOrderShift = (orderShift, shiftDates) => {
    return dispatch => {
        dispatch(updateOrderShiftRequest());

        const newOrderShift = {
            ...orderShift,
            dates: [...shiftDates]
        }

        axios.patch(apis.UPDATE_ORDER_SHIFT_API + orderShift.id + "/", newOrderShift, getAxiosTokenConfig())
            .then(response => {
                dispatch(updateOrderShiftSuccess(response.data));
                notifySuccess(successes.UPDATE_ORDER_SHIFT_SUCCESS);
            })
            .catch(error => {
                dispatch(updateOrderShiftError(error));
                notifyError(errors.UPDATE_ORDER_SHIFT_ERROR);
            })
            .finally(res => {
                dispatch({ type: TOGGLE_ORDER_SHIFT_MODAL });
            });
    };
};

// GET ORDER_PRODUCTS
export const GET_ORDER_PRODUCTS_REQUEST = "GET_ORDER_PRODUCTS_REQUEST";
export const GET_ORDER_PRODUCTS_SUCCESS = "GET_ORDER_PRODUCTS_SUCCESS";
export const GET_ORDER_PRODUCTS_ERROR = "GET_ORDER_PRODUCTS_ERROR";

export const getOrderProductsRequest = () => {
    return {
        type: GET_ORDER_PRODUCTS_REQUEST,
        loading: true
    };
};
export const getOrderProductsSuccess = (orderProducts) => {
    return {
        type: GET_ORDER_PRODUCTS_SUCCESS,
        loading: false,
        error: null,
        orderProducts
    };
};
export const getOrderProductsError = (error) => {
    return {
        type: GET_ORDER_PRODUCTS_ERROR,
        loading: false,
        error
    };
};
export const getOrderProducts = () => {
    return dispatch => {
        dispatch(getOrderProductsRequest());
        axios.get(apis.GET_ORDER_PRODUCTS_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(getOrderProductsSuccess(response.data));
            })
            .catch(error => {
                dispatch(getOrderProductsError(errors.GET_ORDER_PRODUCTS_ERROR));
                notifyError(errors.GET_ORDER_PRODUCTS_ERROR);
            });
    };
};

// ADD ORDER_PRODUCT
export const ADD_ORDER_PRODUCT_REQUEST = "ADD_ORDER_PRODUCT_REQUEST";
export const ADD_ORDER_PRODUCT_SUCCESS = "ADD_ORDER_PRODUCT_SUCCESS";
export const ADD_ORDER_PRODUCT_ERROR = "ADD_ORDER_PRODUCT_ERROR";

export const addOrderProductRequest = () => {
    return {
        type: ADD_ORDER_PRODUCT_REQUEST,
        loading: true
    };
};
export const addOrderProductSuccess = (orderProduct) => {
    return {
        type: ADD_ORDER_PRODUCT_SUCCESS,
        loading: false,
        error: null,
        orderProduct
    };
};
export const addOrderProductError = (error) => {
    return {
        type: ADD_ORDER_PRODUCT_ERROR,
        loading: false,
        error
    };
};
export const addOrderProduct = (orderProduct, productDates) => {
    return dispatch => {
        dispatch(addOrderProductRequest());
        const newOrderProduct = {
            ...orderProduct,
            dates: [...productDates]
        }

        const config = getAxiosTokenConfig();
        config.headers['content-type'] = 'multipart/form-data';

        const product = {};
        const formDataProduct = new FormData();
        let formDataExists = false;
        Object.keys(newOrderProduct).map(key => {
            const value = newOrderProduct[key];
            if (["picture"].includes(key)) {
                if (typeof value !== "string") {
                    if (!value) {
                        product[key] = null;
                    }
                    else {
                        formDataProduct.append(key, value);
                        formDataExists = true;
                    }
                }
            }
            else {
                product[key] = value;
            }
        });

        axios.post(apis.ADD_ORDER_PRODUCT_API, product, getAxiosTokenConfig())
            .then(response => {
                if (formDataExists) {
                    axios.patch(apis.UPDATE_ORDER_PRODUCT_API + response.data.id + "/", formDataProduct, config)
                        .then(response => {
                            dispatch(addOrderProductSuccess(response.data));
                            notifySuccess(successes.ADD_ORDER_PRODUCT_SUCCESS);
                        })
                        .catch(error => {
                            dispatch(addOrderProductError(error));
                            notifyError(errors.ADD_ORDER_PRODUCT_ERROR);
                        });
                }
                else {
                    dispatch(addOrderProductSuccess(response.data));
                    notifySuccess(successes.ADD_ORDER_PRODUCT_SUCCESS);
                }
            })
            .catch(error => {
                dispatch(addOrderProductError(errors.ADD_ORDER_PRODUCT_ERROR));
                notifyError(errors.ADD_ORDER_PRODUCT_ERROR);
            })
            .finally(res => {
                dispatch({ type: TOGGLE_ORDER_PRODUCT_MODAL });
            });
    };
};

// DELETE ORDER_PRODUCT
export const DELETE_ORDER_PRODUCT_REQUEST = "DELETE_ORDER_PRODUCT_REQUEST";
export const DELETE_ORDER_PRODUCT_SUCCESS = "DELETE_ORDER_PRODUCT_SUCCESS";
export const DELETE_ORDER_PRODUCT_ERROR = "DELETE_ORDER_PRODUCT_ERROR";

export const deleteOrderProductRequest = () => {
    return {
        type: DELETE_ORDER_PRODUCT_REQUEST,
        loading: true
    };
};
export const deleteOrderProductSuccess = (orderProductId) => {
    return {
        type: DELETE_ORDER_PRODUCT_SUCCESS,
        loading: false,
        error: null,
        orderProductId
    };
};
export const deleteOrderProductError = (error) => {
    return {
        type: DELETE_ORDER_PRODUCT_ERROR,
        loading: false,
        error
    };
};
export const deleteOrderProduct = (id) => {
    return dispatch => {
        dispatch(deleteOrderProductRequest());
        axios.delete(apis.DELETE_ORDER_PRODUCT_API + id + "/", getAxiosTokenConfig())
            .then(response => {
                dispatch(deleteOrderProductSuccess(id));
                notifySuccess(successes.DELETE_ORDER_PRODUCT_SUCCESS);
            })
            .catch(error => {
                dispatch(deleteOrderProductError(error));
                notifyError(errors.DELETE_ORDER_PRODUCT_ERROR);
            })
            .finally(res => {
                dispatch({ type: TOGGLE_ORDER_PRODUCT_MODAL });
            });
    };
};

// UPDATE ORDER_PRODUCT
export const UPDATE_ORDER_PRODUCT_REQUEST = "UPDATE_ORDER_PRODUCT_REQUEST";
export const UPDATE_ORDER_PRODUCT_SUCCESS = "UPDATE_ORDER_PRODUCT_SUCCESS";
export const UPDATE_ORDER_PRODUCT_ERROR = "UPDATE_ORDER_PRODUCT_ERROR";

export const updateOrderProductRequest = () => {
    return {
        type: UPDATE_ORDER_PRODUCT_REQUEST,
        loading: true
    };
};
export const updateOrderProductSuccess = (orderProduct) => {
    return {
        type: UPDATE_ORDER_PRODUCT_SUCCESS,
        loading: false,
        error: null,
        orderProduct
    };
};
export const updateOrderProductError = (error) => {
    return {
        type: UPDATE_ORDER_PRODUCT_ERROR,
        loading: false,
        error
    };
};
export const updateOrderProduct = (orderProduct, productDates) => {
    return dispatch => {
        dispatch(updateOrderProductRequest());
        const newOrderProduct = {
            ...orderProduct,
            dates: [...productDates]
        }

        const config = getAxiosTokenConfig();
        config.headers['content-type'] = 'multipart/form-data';

        const product = {};
        const formDataProduct = new FormData();
        let formDataExists = false;
        Object.keys(newOrderProduct).map(key => {
            const value = newOrderProduct[key];
            if (["picture"].includes(key)) {
                if (typeof value !== "string") {
                    if (!value) {
                        product[key] = null;
                    }
                    else {
                        formDataProduct.append(key, value);
                        formDataExists = true;
                    }
                }
            }
            else {
                product[key] = value;
            }
        });

        axios.patch(apis.UPDATE_ORDER_PRODUCT_API + orderProduct.id + "/", product, getAxiosTokenConfig())
            .then(response => {
                if (formDataExists) {
                    axios.patch(apis.UPDATE_ORDER_PRODUCT_API + orderProduct.id + "/", formDataProduct, config)
                        .then(response => {
                            dispatch(updateOrderProductSuccess(response.data));
                            notifySuccess(successes.UPDATE_ORDER_PRODUCT_SUCCESS);
                        })
                        .catch(error => {
                            dispatch(updateOrderProductError(error));
                            notifyError(errors.UPDATE_ORDER_PRODUCT_ERROR);
                        });
                }
                else {
                    dispatch(updateOrderProductSuccess(response.data));
                    notifySuccess(successes.UPDATE_ORDER_PRODUCT_SUCCESS);
                }
            })
            .catch(error => {
                dispatch(updateOrderProductError(error));
                notifyError(errors.UPDATE_ORDER_PRODUCT_ERROR);
            })
            .finally(res => {
                dispatch({ type: TOGGLE_ORDER_PRODUCT_MODAL });
            });
    };
};

// GET ORDERS
export const GET_ORDERS_REQUEST = "GET_ORDERS_REQUEST";
export const GET_ORDERS_SUCCESS = "GET_ORDERS_SUCCESS";
export const GET_ORDERS_ERROR = "GET_ORDERS_ERROR";

export const getOrdersRequest = () => {
    return {
        type: GET_ORDERS_REQUEST,
        loading: true
    };
};
export const getOrdersSuccess = ({ results: orders, ...orderPageMeta }) => {
    return {
        type: GET_ORDERS_SUCCESS,
        loading: false,
        error: null,
        orders,
        orderPageMeta,
    };
};
export const getOrdersError = (error) => {
    return {
        type: GET_ORDERS_ERROR,
        loading: false,
        error
    };
};

export const getOrders = (page = 1, size = 10) => {
    return dispatch => {
        dispatch(getOrdersRequest());
        axios.get(`${apis.GET_ORDERS_API}?page=${page}&size=${size}&order_by=shift_from_datetime&reverse=yes`, getAxiosTokenConfig())
            .then(response => {
                dispatch(getOrdersSuccess(response.data));
            })
            .catch(error => {
                dispatch(getOrdersError(errors.GET_ORDERS_ERROR));
                notifyError(errors.GET_ORDERS_ERROR);
            });
    };
};

export const GET_PAST_ORDERS_SUCCESS = "GET_PAST_ORDERS_SUCCESS";

export const getPastOrdersSuccess = ({ results: pastOrders, ...orderPageMeta }) => {
    return {
        type: GET_PAST_ORDERS_SUCCESS,
        loading: false,
        error: null,
        pastOrders,
        orderPageMeta,
    };
};


export const getPastOrders = (page = 1, size = 10) => {
    return dispatch => {
        dispatch(getOrdersRequest());
        axios.get(`${apis.GET_PAST_ORDERS_API}?page=${page}&size=${size}&order_by=shift_from_datetime&reverse=yes`, getAxiosTokenConfig())
            .then(response => {
                dispatch(getPastOrdersSuccess(response.data));
            })
            .catch(error => {
                dispatch(getOrdersError(errors.GET_ORDERS_ERROR));
                notifyError(errors.GET_ORDERS_ERROR);
            });
    };
};


// GET NEW ORDERS
export const GET_NEW_ORDERS_REQUEST = "GET_NEW_ORDERS_REQUEST";
export const GET_NEW_ORDERS_SUCCESS = "GET_NEW_ORDERS_SUCCESS";
export const GET_NEW_ORDERS_ERROR = "GET_NEW_ORDERS_ERROR";

export const getNewOrdersRequest = () => {
    return {
        type: GET_NEW_ORDERS_REQUEST,
        loading: true
    };
};
export const getNewOrdersSuccess = (orders) => {
    return {
        type: GET_NEW_ORDERS_SUCCESS,
        loading: false,
        error: null,
        orders
    };
};
export const getNewOrdersError = (error) => {
    return {
        type: GET_NEW_ORDERS_ERROR,
        loading: false,
        error
    };
};
export const getNewOrders = () => {
    return dispatch => {
        dispatch(getNewOrdersRequest());
        axios.get(apis.GET_NEW_ORDERS_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(getNewOrdersSuccess(response.data));
            })
            .catch(error => {
                dispatch(getNewOrdersError(errors.GET_NEW_ORDERS_ERROR));
                notifyError(errors.GET_NEW_ORDERS_ERROR);
            });
    };
};

// UPDATE ORDER
export const UPDATE_ORDER_REQUEST = "UPDATE_ORDER_REQUEST";
export const UPDATE_ORDER_SUCCESS = "UPDATE_ORDER_SUCCESS";
export const UPDATE_ORDER_ERROR = "UPDATE_ORDER_ERROR";

export const updateOrderRequest = () => {
    return {
        type: UPDATE_ORDER_REQUEST,
        loading: true
    };
};
export const updateOrderSuccess = (order) => {
    return {
        type: UPDATE_ORDER_SUCCESS,
        loading: false,
        error: null,
        order
    };
};
export const updateOrderError = (error) => {
    return {
        type: UPDATE_ORDER_ERROR,
        loading: false,
        error
    };
};
export const updateOrder = (order) => {
    return dispatch => {
        dispatch(updateOrderRequest());
        axios.patch(apis.UPDATE_ORDER_API + order.id + "/", order, getAxiosTokenConfig())
            .then(response => {
                dispatch(updateOrderSuccess(response.data));
                notifySuccess(successes.UPDATE_ORDER_SUCCESS);
            })
            .catch(error => {
                dispatch(updateOrderError(error));
                notifyError(errors.UPDATE_ORDER_ERROR);
            })
            .finally(res => {
                dispatch({ type: TOGGLE_ORDER_MODAL });
            });
    };
};


// ACTIVATE STRIPE
export const ACTIVATE_STRIPE_REQUEST = "ACTIVATE_STRIPE_REQUEST";
export const ACTIVATE_STRIPE_SUCCESS = "ACTIVATE_STRIPE_SUCCESS";
export const ACTIVATE_STRIPE_ERROR = "ACTIVATE_STRIPE_ERROR";

export const activateStripeRequest = () => {
    return {
        type: ACTIVATE_STRIPE_REQUEST,
        loading: true,
    };
};
export const activateStripeSuccess = (connected_account_id) => {
    return {
        type: ACTIVATE_STRIPE_SUCCESS,
        loading: false,
        error: null,
        connected_account_id: connected_account_id
    };
};
export const activateStripeError = (error) => {
    return {
        type: ACTIVATE_STRIPE_ERROR,
        loading: false,
        error
    };
};
export const activateStripe = (code) => {
    return dispatch => {
        dispatch(activateStripeRequest());
        const data = {
            code: code
        }
        axios.post(apis.ACTIVATE_STRIPE_API, data, getAxiosTokenConfig())
            .then(response => {
                dispatch(activateStripeSuccess(response.data.connected_account_id));
                notifySuccess(successes.ACTIVATE_STRIPE_SUCCESS);
                history.push(routes.ORDER_SETTINGS);
            })
            .catch(error => {
                dispatch(activateStripeError(errors.ACTIVATE_STRIPE_ERROR));
                notifyError(errors.ACTIVATE_STRIPE_ERROR);
            })
    };
};

// DEACTIVATE STRIPE
export const DEACTIVATE_STRIPE_REQUEST = "DEACTIVATE_STRIPE_REQUEST";
export const DEACTIVATE_STRIPE_SUCCESS = "DEACTIVATE_STRIPE_SUCCESS";
export const DEACTIVATE_STRIPE_ERROR = "DEACTIVATE_STRIPE_ERROR";

export const deactivateStripeRequest = () => {
    return {
        type: DEACTIVATE_STRIPE_REQUEST,
        loading: true
    };
};
export const deactivateStripeSuccess = () => {
    return {
        type: DEACTIVATE_STRIPE_SUCCESS,
        loading: false,
        error: null
    };
};
export const deactivateStripeError = (error) => {
    return {
        type: DEACTIVATE_STRIPE_ERROR,
        loading: false,
        error
    };
};
export const deactivateStripe = () => {
    return dispatch => {
        dispatch(deactivateStripeRequest());
        axios.post(apis.DEACTIVATE_STRIPE_API, {}, getAxiosTokenConfig())
            .then(response => {
                dispatch(deactivateStripeSuccess());
                notifySuccess(successes.DEACTIVATE_STRIPE_SUCCESS);
            })
            .catch(error => {
                dispatch(deactivateStripeError(errors.DEACTIVATE_STRIPE_ERROR));
                notifyError(errors.DEACTIVATE_STRIPE_ERROR);
            })
    };
};

// MARK AS READ ORDER
export const MARK_AS_READ_ORDER_REQUEST = "MARK_AS_READ_ORDER_REQUEST";
export const MARK_AS_READ_ORDER_SUCCESS = "MARK_AS_READ_ORDER_SUCCESS";
export const MARK_AS_READ_ORDER_ERROR = "MARK_AS_READ_ORDER_ERROR";

export const markAsReadOrderRequest = () => {
    return {
        type: MARK_AS_READ_ORDER_REQUEST,
        loading: true
    };
};
export const markAsReadOrderSuccess = (order) => {
    return {
        type: MARK_AS_READ_ORDER_SUCCESS,
        loading: false,
        error: null,
        order
    };
};
export const markAsReadOrderError = (error) => {
    return {
        type: MARK_AS_READ_ORDER_ERROR,
        loading: false,
        error
    };
};
export const markAsReadOrder = (id) => {
    return dispatch => {
        const data = {
            read: true
        }
        dispatch(markAsReadOrderRequest());
        axios.patch(apis.MARK_AS_READ_ORDER_API + id + "/", data, getAxiosTokenConfig())
            .then(response => {
                dispatch(markAsReadOrderSuccess(response.data));
            })
            .catch(error => {
                dispatch(markAsReadOrderError(error));
            });
    };
};

// MARK ALL ORDERS AS READ
export const MARK_AS_READ_ALL_ORDERS_REQUEST = "MARK_AS_READ_ALL_ORDERS_REQUEST";
export const MARK_AS_READ_ALL_ORDERS_SUCCESS = "MARK_AS_READ_ALL_ORDERS_SUCCESS";
export const MARK_AS_READ_ALL_ORDERS_ERROR = "MARK_AS_READ_ALL_ORDERS_ERROR";

export const markAsReadAllOrdersRequest = () => ({ type: MARK_AS_READ_ALL_ORDERS_REQUEST });
export const markAsReadAllOrdersSuccess = (result) => ({ type: MARK_AS_READ_ALL_ORDERS_SUCCESS, result });
export const markAsReadAllOrdersError = (error) => ({ type: MARK_AS_READ_ALL_ORDERS_ERROR, error });

// Endpoint is no longuer exposed in backend since the function is not used for now
export const markAsReadAllOrders = () => {
    return dispatch => {
        dispatch(markAsReadAllOrdersRequest());
        return axios
            .patch(apis.MARK_AS_READ_ALL_ORDERS_API, {}, getAxiosTokenConfig())
            .then(res => dispatch(markAsReadAllOrdersSuccess(res.data)))
            .catch(err => dispatch(markAsReadAllOrdersError(err)));
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/orders.js